import React, {
  ReactElement,
  Fragment,
} from 'react';
import {Button} from '@mui/material';
import { SchemaWithClient } from '../../types/SchemaWithClient';
import { Entity } from '../../types/entities/Entity';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';

type Props<T extends Entity> = {
  schema: SchemaWithClient<T>;
};
export const ChangeTabConfirmDialog = ({
                                onClose,
                                onSubmit,
                                         onCloseWithOutSaving,
                              }: {
  onClose: () => void;
  onSubmit: () => void;
  onCloseWithOutSaving: () => void;
}): ReactElement => {

  return (
    <>
      <Dialog
        open={true}
        onClose={() => {
          onClose();
        }}
      >
        <DialogTitle>
            You have unsaved changes. Please save your work before leaving.
        </DialogTitle>
        <DialogActions
          sx={{
            gap: '10px',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
          }}
        >
          <Button
            variant={'outlined'}
            onClick={() => {
              onClose();
            }}
            sx={{
              width: {
                xs: '100%',
                md: '100px',
              },
            }}
          >
            Cancel
          </Button>
          <Button
            variant={'outlined'}
            color={'error'}
            onClick={() => {
              onCloseWithOutSaving();
            }}
            sx={{
              ml: '0px !important',
              width: {
                xs: '100%',
                md: '240px',
              },
            }}
          >
            Discard changes
          </Button>
          <Button
            variant={'contained'}
            color={'primary'}
            onClick={() => {
              onSubmit();
            }}
            sx={{
              ml: '0px !important',
              width: {
                xs: '100%',
                md: '180px',
              },
            }}
            autoFocus
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
